import * as React from "react";

const SvgReadyforShipment = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3Zm0 2h-2v5a1 1 0 0 1-1.458.89l-.097-.058L12 9.202l-2.445 1.63a1 1 0 0 1-1.55-.72L8 10V5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Zm-4 0h-4v3.13l1.445-.962a1 1 0 0 1 .994-.066l.116.066L14 8.13V5Z"
        fill={color}
        fillRule="nonzero"
      />
      <g transform="translate(10 10)">
        <circle fill="#059669" cx={7} cy={7} r={7} />
        <path
          d="M7.4 2.4a1.5 1.5 0 0 1 1.477 1.236l.013.096.044.021a3.501 3.501 0 0 1 1.963 3.012l.003.135v1.58c0 .113.038.223.106.313l.045.051.703.702a.5.5 0 0 1-.297.851l-.057.003h-2a2 2 0 0 1-3.998.1l-.002-.1h-2a.5.5 0 0 1-.392-.811l.038-.043.703-.702a.516.516 0 0 0 .147-.297L3.9 8.48V6.9c0-1.36.782-2.57 1.966-3.147l.043-.02.001-.008a1.5 1.5 0 0 1 1.402-1.322L7.4 2.4Zm-1 8a1 1 0 0 0 1.997.075L8.4 10.4h-2Zm3.812-1-.057-.08a1.516 1.516 0 0 1-.252-.74l-.003-.1V6.9a2.501 2.501 0 0 0-1.667-2.358.5.5 0 0 1-.33-.409L7.9 4.071V3.9a.5.5 0 0 0-.997-.058L6.9 3.9v.17a.5.5 0 0 1-.333.472 2.501 2.501 0 0 0-1.664 2.244L4.9 6.9v1.58c0 .3-.09.593-.255.84l-.057.08h5.624Z"
          fill="#F8FAFC"
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

export default SvgReadyforShipment;
